import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oracleCloudHcm = defineConnector({
  identifier: "oracleCloudHcm",
  name: "Oracle Cloud HCM",
  tagLine: "Cloud human capital management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://.*\\.oraclecloud\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your Oracle Cloud HCM API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. Sign in to your Oracle Cloud console
2. Navigate to **Identity & Security › Domains › Applications**
3. Create a confidential application and generate a client ID and secret
4. Grant the application the required HCM scopes`,
        },
      ],
    },
    {
      title: "Enter your Oracle Cloud HCM details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://abcd-test.fa.us2.oraclecloud.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "Your Oracle Cloud HCM instance URL (e.g., https://abcd-test.fa.us2.oraclecloud.com).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ instanceUrl }) => {
      const host = new URL(instanceUrl ?? "").hostname;
      const idcsHost = host.replace(
        /\.oraclecloud\.com$/,
        ".identity.oraclecloud.com"
      );
      return `https://${idcsHost}/oauth2/v1/token`;
    },
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => ["urn:opc:idm:__myscopes__"],
  },
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/hcmRestApi/resources/latest/emps?limit=1`,
  },
  publicEnvVars: ({ instanceUrl }) => ({
    ORACLE_CLOUD_HCM_URL: instanceUrl || "",
  }),
});
